import svg from "./ingredient-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const IngredientIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.grey[900]
);

export default IngredientIcon;
